import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  uploadButton: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 12,
    '& svg': {
      width: 16,
      height: 16
    }
  }
})

export default useStyles
